import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule,MAT_DATE_LOCALE } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableExporterModule } from 'mat-table-exporter';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import {MatTreeModule} from '@angular/material/tree';

const MaterialComponents = [
  MatButtonModule,
  MatToolbarModule,
  MatIconModule,
  MatMenuModule,
  MatTabsModule,
  MatDatepickerModule,
  MatNativeDateModule,  
  MatFormFieldModule,
  MatCardModule,
  MatSlideToggleModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatChipsModule,
  MatSelectModule,
  MatExpansionModule,
  MatTableExporterModule,
  MatProgressBarModule,
  CdkAccordionModule,
  MatCheckboxModule,
  MatAutocompleteModule,
  MatTreeModule
];

@NgModule({
  imports: [MaterialComponents],
  exports: [MaterialComponents,MatDatepickerModule,
    MatNativeDateModule],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
 ],
})
export class MaterialModule {}
